module.exports = __webpack_public_path__ + "./Lina_pbw_a49504a7b651c6db9fd44599b5ea4213.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2023/Lina_pbw.png
// module id = 599
// module chunks = 0